import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d371984"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "2",
  style: {"text-align":"center","font-weight":"bold"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  colspan: "2",
  style: {"text-align":"right"}
}

import { reactive, watch } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodJP',
  props: {
    stic: { type: Boolean },
    withdrawId: {},
    wireForm: {},
    phonesData: {},
    fromDealing: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const stic = props.stic ?? true;
const fromDealing = props.fromDealing ?? false;

// seed editable form from wireForm for stic mode
const seed = () => {
  const info = props.wireForm?.bankInfo || {};
  const phonesData = props.phonesData || {};

  return {
    bankCode: info.bankCode ?? info.bankcode ?? "",
    branchCode: info.branchCode ?? info.branchcode ?? "",
    accountNo: info.accountNo ?? info.accountNumber ?? "",
    firstName: info.firstName ?? "",
    lastName: info.lastName ?? "",
    bankCountryCode: info.bankCountry ?? "",
    bankCountry:
      phonesData[info.bankCountry?.toLowerCase?.()]?.name ??
      info.bankCountry ??
      "",
    phoneNumber: info.phoneNumber ?? "",
  };
};
const editForm = reactive(seed());

// re-seed when wireForm changes
watch(
  () => props.wireForm?.bankInfo,
  () => {
    const v = seed();
    Object.assign(editForm, v);
  },
  { deep: true }
);

const extractErrorDescription = (err: any) => {
  let data: any = err?.response?.data ?? err;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      // keep as string
    }
  }
  return data?.description || data?.message || err?.message || String(err);
};

const { t } = useI18n();

// required field validator
const findMissingField = (info: any): string | null => {
  const fields: Array<[keyof typeof info, string]> = [
    ["bankCode", t("fields.financialInstitutionCode")],
    ["branchCode", t("fields.branchCode")],
    ["accountNo", t("fields.accountNo")],
    ["firstName", t("fields.firstName")],
    ["lastName", t("fields.lastName")],
    ["phoneNumber", t("fields.phone")],
  ];
  for (const [key, label] of fields) {
    const val = info?.[key];
    const s = typeof val === "string" ? val.trim() : String(val ?? "").trim();
    if (!s) return label;
  }
  return null;
};

const submitSTICPayment = async () => {
  try {
    const info = stic ? editForm : seed();

    // 1) required fields
    const missing = findMissingField(info);
    if (missing) {
      return MsgPrompt.warning(`${missing} is required`);
    }

    // 2) submit
    const fd = new FormData();
    fd.append("id", String(props.withdrawId));
    const payload: Record<string, any> = {
      bankcode: info.bankCode,
      branchcode: info.branchCode,
      accountNo: info.accountNo,
      firstName: info.firstName,
      lastName: info.lastName,
      bankCountry: info.bankCountryCode,
      phoneNumber: info.phoneNumber,
    };
    Object.entries(payload).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") fd.append(k, String(v));
    });

    await PaymentService.submitSTICWithdraw(fd);
    MsgPrompt.success("STIC Payment Submitted");
  } catch (error) {
    MsgPrompt.error(extractErrorDescription(error));
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.$t("fields.paymentMethod")), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.method")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.payment.paymentServiceName), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.countryOfBank")), 1),
      _createElementVNode("td", null, _toDisplayString(editForm.bankCountry), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.financialInstitutionCode")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editForm.bankCode) = $event))
            }, null, 512)), [
              [_vModelText, editForm.bankCode]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.wireForm.bankInfo.bankCode), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.branchCode")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editForm.branchCode) = $event))
            }, null, 512)), [
              [_vModelText, editForm.branchCode]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.wireForm.bankInfo.branchCode ?? _ctx.wireForm.bankInfo.branchcode), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editForm.accountNo) = $event))
            }, null, 512)), [
              [_vModelText, editForm.accountNo]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.wireForm.bankInfo.accountNo), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.firstName")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editForm.firstName) = $event))
            }, null, 512)), [
              [_vModelText, editForm.firstName]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.wireForm.accountInfo.user.firstName), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.lastName")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editForm.lastName) = $event))
            }, null, 512)), [
              [_vModelText, editForm.lastName]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.wireForm.accountInfo.user.lastName), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.phone")), 1),
      _createElementVNode("td", null, [
        (_unref(stic) && !_unref(fromDealing))
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editForm.phoneNumber) = $event))
            }, null, 512)), [
              [_vModelText, editForm.phoneNumber]
            ])
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.phonesData[_ctx.wireForm.bankInfo.bankCountry.toLowerCase?.()].dialCode +
          _ctx.wireForm.accountInfo.user.phone), 1)
            ], 64))
      ])
    ]),
    (_unref(stic) && !_unref(fromDealing))
      ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
          _createElementVNode("td", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-light btn-success btn-sm",
              onClick: submitSTICPayment
            }, _toDisplayString(_ctx.$t("action.submit") + " STIC Payment"), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})